import { paginated } from '../helpers/paginated'

const initialState = {
  page: {
    limit: 30,
    offset: 0
  }
}

const attendanceMonitorModule = {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    ...paginated.mutations
  },
}

export default attendanceMonitorModule
export { initialState }
